module.exports = __webpack_public_path__ + "static/media/user_avatar.f07d66e0.png";